export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_10.6ea3ecaf.jpg";